const consent_modal = require('./cs/consent_modal')
const settings_modal  = require('./cs/settings_modal')

module.exports = {
    callLinkName: 'Nastavení cookies',
    consent_modal,
    settings_modal
}
